import React from 'react';
import { Controller } from 'react-hook-form';

import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Typography,
  TextField,
  Stack,
  Divider,
  Grid
} from '@mui/material';

import CreatableSelect from 'react-select/creatable';

import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import SaveIcon from '@mui/icons-material/Save';

export const EditarComboModal = (
  {
    open : {open = false, combo = {}, diaNormalized = ""}, 
    categoriasComidasState = [], 
    control, 
    setOpen, 
    funcAgregarNuevaComida, 
    funcUpdateComboSelected 
  }) => {

  return (
    <Dialog
    PaperProps={{ sx: { width: "50%", height: "52%" } }}
    open={open}
    maxWidth='lg'
    >

      <DialogTitle sx={{textTransform: 'uppercase'}} className='text-mem text-center'>Editar Combo #{combo.numeracion}</DialogTitle>
      <Divider />

      <DialogContent>

        <Stack mt={2} mb={2}>
            <Typography fontWeight='bold'>Guarnición</Typography>
            <Controller
            control={control}
            name="comboEdit.guarnicion"
            render={({ field }) => (
                <CreatableSelect 
                placeholder='Seleccionar comida'
                onCreateOption={(e) => funcAgregarNuevaComida({value: e, categoriaAlmuerzoId: 1, editCombo: true})}
                isClearable 
                options={categoriasComidasState.find(x => x.id === 1)?.comidas ?? []}
                getOptionLabel={(option) => option.descripcion}
                getOptionValue={(option) => option.id}
                // formatCreateLabel={(inputValue) => `Crear "${inputValue}"`}
                onChange={(e) => field.onChange(e === null ? {} : e)}
                value={categoriasComidasState.find(x => x.id === 1)?.comidas.find(x => x.id === field.value?.id)}
                />
            )}
            />
        </Stack>

         <Stack mb={2}>
            <Typography fontWeight='bold'>Acompañamiento</Typography>
            <Controller
            control={control}
            name="comboEdit.acompañamiento"
            render={({ field }) => (
                <CreatableSelect 
                placeholder='Seleccionar comida'
                onCreateOption={(e) => funcAgregarNuevaComida({value: e, categoriaAlmuerzoId: 2, comboEdit: true})}
                isClearable 
                options={categoriasComidasState.find(x => x.id === 2)?.comidas ?? []}
                getOptionLabel={(option) => option.descripcion}
                getOptionValue={(option) => option}
                // formatCreateLabel={(inputValue) => `Crear "${inputValue}"`}
                onChange={(e) => field.onChange(e === null ? {} : e)}
                value={categoriasComidasState.find(x => x.id === 2)?.comidas.find(x => x.id === field.value?.id)}
                />
            )}
            />
            </Stack>
        
            <Stack mb={2}>
            <Typography fontWeight='bold'>Ensalada</Typography>
            <Controller
            control={control}
            name="comboEdit.ensalada"
            render={({ field }) => (
                <CreatableSelect 
                placeholder='Seleccionar comida'
                onCreateOption={(e) => funcAgregarNuevaComida({value: e, categoriaAlmuerzoId: 3, comboEdit: true})}
                isClearable 
                options={categoriasComidasState.find(x => x.id === 3)?.comidas ?? []}
                getOptionLabel={(option) => option.descripcion}
                getOptionValue={(option) => option.id}
                // formatCreateLabel={(inputValue) => `Crear "${inputValue}"`}
                onChange={(e) => field.onChange(e === null ? {} : e)}
                value={categoriasComidasState.find(x => x.id === 3)?.comidas.find(x => x.id === field.value?.id)}
                />
            )}
            />
            </Stack>

            <Stack display='flex' className='col-12'>
            <Typography fontWeight='bold'>Numeración</Typography>
                <Grid item xs={5}>
                <Controller 
                control={control}
                name='comboEdit.numeracion'
                render={({field}) => (
                    <TextField 
                    disabled
                    sx={{minWidth: '100%'}}
                    type='number'
                    variant='outlined' 
                    onChange={(e) => field.onChange(e)}
                    value={field.value}
                    
                    />
                )}
                />
                </Grid>
            </Stack>
          
      </DialogContent>

      <DialogActions className='justify-content-center'>
        <button onClick={() => setOpen({open: false, combo: {}})} className='btn btn-danger'><DoNotDisturbAltIcon sx={{marginTop: -0.5, marginRight: 0.5}} />CANCELAR</button>
        <button onClick={() => funcUpdateComboSelected({diaNormalized})} className='btn btn-primary-mem'><SaveIcon sx={{marginTop: -0.5, marginRight: 0.5}} />GUARDAR</button>
      </DialogActions>

    </Dialog>
  )
}
